module.exports = __webpack_public_path__ + "static/img/2_3_1.f87b0afa.png";